import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: "history",
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/news_information',
          name: 'News',
          component: resolve => require(['@/view/News'], resolve),
          meta: {
            title: '新闻'
          },
          children: [
            {
              path: '/news_information',
              redirect: '/news_information/message'
            },
            {
              path: '/news_information/message',
              name: 'message',
              component: resolve => require(['../view/NewsMessage.vue'], resolve),
              meta: {
                title: '新闻信息'
              }
            },
            {
              path: '/news_information/notice',
              name: 'notice',
              component: resolve => require(['../view/NewsNotice.vue'], resolve),
              meta: {
                title: '通知公告',

              }
            },
            {
              path: '/news_information/artical_detail',
              name: 'newsdetail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '新闻动态详情内容'
              }
            },


          ]
        },
        {
          path: '/public_project',
          name: 'public_pro',
          component: resolve => require(['../view/News.vue'], resolve),
          meta: {
            title: '公益项目'
          },
          children: [
            {
              path: '/public_project',
              redirect: '/public_project/special'
            },
            {
              path: '/public_project/special',
              name: 'special',
              component: resolve => require(['../view/SpecialList.vue'], resolve),
              meta: {
                title: '专项基金'
              }
            },
            {
              path: '/public_project/special/list',
              name: 'special_list',
              component: resolve => require(['../view/SpecialMore.vue'], resolve),
              meta: {
                title: '专项基金列表'
              }
            },
            {
              path: '/public_project/home',
              name: 'prohome',
              component: resolve => require(['../view/Special.vue'], resolve),
              meta: {
                title: '国内项目'
              }
            },
            {
              path: '/public_project/international',
              name: 'international',
              component: resolve => require(['../view/Special.vue'], resolve),
              meta: {
                title: '国际项目'
              }
            },
            {
              path: '/public_project/artical_detail',
              name: 'publicdetail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '公益项目详情内容'
              }
            },

          ]
        },
        // {
        //   path: '/history',
        //   name: 'history',
        //   component: resolve => require(['../view/News.vue'], resolve),
        //   meta: {
        //     title: '历史沿革'
        //   },
        //   children: [
        //     {
        //       path: '/history',
        //       redirect: '/history/introduce'
        //     },
        //     {
        //       path: '/history/introduce',
        //       name: 'introduce',
        //       component: resolve => require(['../view/HistorIntroduce.vue'], resolve),
        //       meta: {
        //         title: '历届董事会介绍'
        //       }
        //     },
        //     {
        //       path: '/history/major_pro',
        //       name: 'major_pro',
        //       component: resolve => require(['../view/Special.vue'], resolve),
        //       meta: {
        //         title: '历年重大项目'
        //       }
        //     },
        //     {
        //       path: '/history/artical_detail',
        //       name: 'majordetail',
        //       component: resolve => require(['../view/ArticalDetail.vue'], resolve),
        //       meta: {
        //         title: '历年重大项目详情内容'
        //       }
        //     },

        //   ]
        // },
        {
          path: '/public_info',
          name: 'public_info',
          component: resolve => require(['../view/News.vue'], resolve),
          meta: {
            title: '信息公示'
          },
          children: [
            {
              path: '/public_info',
              redirect: '/public_info/year_report'
            },
            {
              path: '/public_info/year_report',
              name: 'year_report',
              component: resolve => require(['../view/PublicYearReport.vue'], resolve),
              meta: {
                title: '年度工作报告'
              }
            },
            {
              path: '/public_info/finance_report',
              name: 'finance_report',
              component: resolve => require(['../view/PublicFinanceReport.vue'], resolve),
              meta: {
                title: '财务信息审计报告'
              }
            },
            {
              path: '/public_info/special_report',
              name: 'special_report',
              component: resolve => require(['../view/PublicSpecialReport.vue'], resolve),
              meta: {
                title: '专项信息审核报告'
              }
            },
            {
              path: '/public_info/rules',
              name: 'rules',
              component: resolve => require(['../view/PublicRules.vue'], resolve),
              meta: {
                title: '规章制度'
              }
            },
            {
              path: '/public_info/pro_disclosure',
              name: 'disclosure',
              component: resolve => require(['../view/ProDisclosure.vue'], resolve),
              meta: {
                title: '项目披露'
              }
            },
            {
              path: '/public_info/other_info',
              name: '/other_info',
              component: resolve => require(['../view/PublicProHistory.vue'], resolve),
              meta: {
                title: '其他公示信息'
              }
            },
            {
              path: '/public_info/artical_detail',
              name: 'pub_detail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '信息公示详情内容'
              }
            },
          ]
        },
        {
          path: '/regulation',
          name: 'regulation',
          component: resolve => require(['../view/News.vue'], resolve),
          meta: {
            title: '政策法规'
          },
          children: [
            {
              path: '/regulation',
              redirect: '/regulation/index'
            },
            {
              path: '/regulation/index',
              name: 'regindex',
              component: resolve => require(['../view/Regulation.vue'], resolve),
              meta: {
                title: '政策法规'
              },
            },
            {
              path: '/regulation/artical_detail',
              name: 'regdetail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '政策法规详情内容'
              }
            },
          ]
        },
        {
          path: '/party_work',
          name: 'party_work',
          component: resolve => require(['../view/News.vue'], resolve),
          children: [
            {
              path: '/party_work',
              redirect: '/party_work/index'
            },
            {
              path: '/party_work/index',
              name: 'patindex',
              component: resolve => require(['../view/Regulation.vue'], resolve),
              meta: {
                title: '党群工作'
              },
            },
            {
              path: '/party_work/artical_detail',
              name: 'patdetail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '党群工作详情内容'
              }
            },
          ]
        },
        {
          path: '/download',
          name: 'download',
          component: resolve => require(['../view/News.vue'], resolve),

          children: [
            {
              path: '/download',
              redirect: '/download/index'
            },
            {
              path: '/download/index',
              name: 'download_index',
              component: resolve => require(['../view/DownLoad.vue'], resolve),
              title: "下载中心"
            },
            {
              path: '/download/artical_detail',
              name: 'download_detail',
              component: resolve => require(['../view/ArticalDetail.vue'], resolve),
              meta: {
                title: '下载中心详情内容'
              }
            }
          ]
        },
        {
          path: '/about_us',
          name: 'about_us',
          meta: {
            title: '关于我们'
          },
          component: resolve => require(['../view/News.vue'], resolve),
          // component: resolve => require(['../view/Aboutus.vue'], resolve),
          children: [
            {
              path: '/about_us',
              redirect: '/about_us/introduce'
            },
            {
              path: '/about_us/introduce',
              name: 'about_us_introduce',
              component: resolve => require(['../view/HomeIntroduce.vue'], resolve),
              title: "基金会简介"
            },
            {
              path: '/about_us/rules',
              name: 'about_us_rules',
              component: resolve => require(['../view/HomeRules.vue'], resolve),
              title: "基金会章程"
            },
            {
              path: '/about_us/organization',
              name: 'about_us_organization',
              component: resolve => require(['../view/HomeIntroduce.vue'], resolve),
              title: "组织结构"
            },
            {
              path: '/about_us/history_introduce',
              name: 'about_us_history_introduce',
              component: resolve => require(['../view/HistorIntroduce.vue'], resolve),
              meta: {
                title: '往届理事会'
              }
            },
            {
              path: '/about_us/council',
              name: 'about_us_council',
              component: resolve => require(['../view/CouncilIntroduce.vue'], resolve),
              title: "本届理事会"
            },
            {
              path: '/about_us/office_structure',
              name: 'about_us/office_structure',
              component: resolve => require(['../view/OfficeStructure.vue'], resolve),
              title: "办事机构"
            },
            {
              path: '/about_us/office_staff',
              name: 'about_us/office_staff',
              component: resolve => require(['../view/HomeIntroduce.vue'], resolve),
              title: "办公人员"
            },
            {
              path: '/about_us/account_information',
              name: 'about_us/account_information',
              component: resolve => require(['../view/Account.vue'], resolve),
              title: "账户信息"
            },
            {
              path: '/about_us/contact_us',
              name: 'about_us/contact_us',
              component: resolve => require(['../view/ContactUs.vue'], resolve),
              title: "联系我们"
            },
          ]
        },
        {
          path: '/search',
          name: 'search',
          component: resolve => require(['../view/search.vue'], resolve),
          title: "搜索内容"
        }
        // {
        //   path: '/software',
        //   name: 'software',
        //   component: resolve => require(['@/view/Software'], resolve),
        //   meta: {
        //     title: '软件产品'
        //   },
        //   children: [
        //     {
        //       path: '/software',
        //       redirect: '/software/smartTown'
        //     },
        //     {
        //       path: '/software/smartTown',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_smartTown'], resolve),
        //       meta: {
        //         title: '软件产品丨智能小镇管理系统'
        //       }
        //     },
        //     {
        //       path: '/software/bigData',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_bigData'], resolve),
        //       meta: {
        //         title: '软件产品丨大数据管理系统'
        //       }
        //     }
        //   ]
        // }, {
        //   path: '/service',
        //   name: 'service',
        //   component: resolve => require(['@/view/Service'], resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // }, {
        //   path: '/newsinformation',
        //   name: 'newsinformation',
        //   component: resolve => require(['@/view/NewsInformation'], resolve),
        //   meta: {
        //     title: '新闻动态'
        //   }
        // }, {
        //   path: '/companyintroduction',
        //   name: 'companyintroduction',
        //   component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        //   meta: {
        //     title: '公司介绍'
        //   }
        // }, {
        //   path: '/jobchance',
        //   name: 'jobchance',
        //   component: resolve => require(['@/view/JobChance'], resolve),
        //   meta: {
        //     title: '工作机会'
        //   }
        // }, {
        //   path: '/contactus',
        //   name: 'contactus',
        //   component: resolve => require(['@/view/ContactUs'], resolve),
        //   meta: {
        //     title: '联系我们'
        //   }
        // },
        // {
        //   path: '/servicedetail',
        //   name: 'servicedetail',
        //   component: resolve => require(['@/view/ServiceDetail'], resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 } // 将滚动位置设置为顶部
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js